export { ASSETS } from '_/constants/assets-paths'
export { ENVS } from '_/constants/envs'
export { VIEW } from '_/constants/view'

export const CONST = {
	PRODUCTION: 'production',
	SERVER: 'server',
	CLIENT: 'client',
	UNKNOWN: 'unknown',
} as const

export const LOCAL_HREFS = {
	HOME: '/',
}
